// @react-native-aria doesn't exports overlays
import type { Placement } from '@react-aria/overlays'

export type TOverlayPlacement =
  | 'top'
  | 'bottom'
  | 'right'
  | 'left'
  | 'top-start'
  | 'top-end'
  | 'bottom-start'
  | 'bottom-end'
  | 'left-start'
  | 'left-end'
  | 'right-start'
  | 'right-end'

export const toReactAriaPlacement = (placement: TOverlayPlacement) => {
  const mapPositions: Record<TOverlayPlacement, Placement> = {
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right',
    'top-start': 'top start',
    'top-end': 'top end',
    'bottom-start': 'bottom start',
    'bottom-end': 'bottom end',
    'left-start': 'left top',
    'left-end': 'left bottom',
    'right-start': 'right top',
    'right-end': 'right bottom',
  }

  return mapPositions[placement]
}
